import styled from 'styled-components';

export const ListingBodyMainWrap = styled.div(
    props => `
        max-width:120rem;
        margin:0 auto;
        width:100%;
        display: flex;
    `
);

export const ListingBodyOuterWrap = styled.div(
    props => `
        width:100%;
        display:flex;
        flex-direction: column;
        padding: ${props.theme.spacing.large.l75} ${props.theme.spacing.large.l30} ${props.theme.spacing.large.l20};
        background-color: ${props.theme.colors.white.base};
        border-radius: 1rem;
        box-shadow: 0 3px 30px 0 rgba(0, 0, 0, 0.1);
        z-index: 1;
        margin-top: -${props.theme.spacing.large.l60};
        margin-bottom: ${props.theme.spacing.large.l40};
    `
);